import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  FormControl, InputLabel, Select, MenuItem, Chip, Typography,
} from '@material-ui/core';
import * as A from '../store/lineageActions';

const TYPE_LABEL = {
  application: 'Application',
  service: 'Service',
  api: 'API',
  file: 'File / Feed',
  other: 'Type',
};

// Single-select picker (issue #645): one reference per node. Storage stays an ARRAY
// (node.data.details.nodeRefIds) — a 0- or 1-element list — so the server-side
// JSON_CONTAINS usage query and the appType-reset logic keep working unchanged, and a
// legacy multi-value node collapses to its first (primary) ref the next time it's edited.
class NodeRefMultiPicker extends Component {
  handleChange = (e) => {
    const {node, activeNodeId, updateNode, nodeRefs} = this.props;
    const id = e.target.value; // scalar; '' when cleared (None)
    const nodeRefIds = id ? [id] : [];
    const updates = {
      data: {
        ...node.data,
        details: {...(node.data.details || {}), nodeRefIds},
      },
    };
    // Selecting a reference names an unlabeled node after it (single, deterministic pick).
    if (id && !(node.data.label || '').trim()) {
      const ref = nodeRefs.find((r) => r.id === id);
      if (ref) updates.data.label = ref.name;
    }
    updateNode(activeNodeId, updates);
  };

  render() {
    const {node, nodeRefs} = this.props;
    if (!node) return null;

    const appType = node.data.appType || 'application';
    const selected = (node.data.details && node.data.details.nodeRefIds) || [];
    const value = selected[0] || ''; // a legacy multi-value node shows its first (primary) ref
    const activeOptions = nodeRefs.filter((r) => r.isActive !== 0 && r.nodeType === appType);
    // Keep the current selection selectable even if it's inactive or of another type (legacy),
    // so the single-select value is never out-of-range (no MUI warning) and shows its label.
    const options = [...activeOptions];
    if (value && !options.some((r) => r.id === value)) {
      const cur = nodeRefs.find((r) => r.id === value);
      if (cur) options.push(cur);
    }
    const label = TYPE_LABEL[appType] || 'Reference';

    const nameOf = (r) => (r.isActive === 0 ? `${r.name} (inactive)` : r.name);
    const chipLabel = (id) => {
      const ref = nodeRefs.find((r) => r.id === id);
      return ref ? nameOf(ref) : id;
    };

    return (
      <FormControl fullWidth margin="dense">
        <InputLabel>{label}</InputLabel>
        <Select
          value={value}
          onChange={this.handleChange}
          inputProps={{'data-testid': 'node-ref-picker'}}
          renderValue={(id) => (
            <Chip
              key={id}
              label={chipLabel(id)}
              size="small"
              data-testid={`node-ref-chip-${id}`}
            />
          )}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          {options.map((r) => (
            <MenuItem key={r.id} value={r.id}>{nameOf(r)}</MenuItem>
          ))}
          {options.length === 0 && (
            <MenuItem disabled>
              <Typography variant="caption" color="textSecondary">
                No references yet — add from the toolbar Settings menu
              </Typography>
            </MenuItem>
          )}
        </Select>
      </FormControl>
    );
  }
}

const mapStateToProps = (state) => ({
  nodeRefs: state.lineageReducer.nodeRefs || [],
});

export default connect(mapStateToProps, {updateNode: A.updateNode})(NodeRefMultiPicker);
